import { render, staticRenderFns } from "./FormationsContinues.vue?vue&type=template&id=3385338c"
import script from "./FormationsContinues.vue?vue&type=script&lang=js"
export * from "./FormationsContinues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports